import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  showExperience: {
    id: 'views.AuthoritiesView.Authority.showExperience',
    defaultMessage: 'POZNAJ OSIĄGNIĘCIA ZAWODOWE'
  },
  showCV: {
    id: 'views.AuthoritiesView.Authority.showCV',
    defaultMessage: 'PEŁEN ŻYCIORYS'
  }
});



// WEBPACK FOOTER //
// ./src/views/Authorities/components/Authority/Authority.intl.js